import {LIST_DRAWING_LO12V2} from "./types";

const init = {
    countDownTimer: 0,
    isStopBet: false,
    newResult: null,
    oldResult: null,
    active: []
}


export default (state = init, {type, payload}) => {
    switch (type) {
        case LIST_DRAWING_LO12V2:
            return {
                ...state,
                ...payload,
            };
        default:
            return state;
    }
}
